import { useQuery } from '@tanstack/react-query';
import { listConfigsByType, ListConfigsResponse } from '../services/configs-api';

/**
 * TanStack Query hook for fetching configs filtered by configType.
 * Used by ReferenceSelect dropdowns.
 */
export function useConfigsByType(configType: string | undefined) {
  return useQuery<ListConfigsResponse>({
    queryKey: ['configs', { configType }],
    queryFn: () => listConfigsByType(configType!),
    enabled: !!configType,
    staleTime: 60_000, // 1 minute — reference data doesn't change often
  });
}
